import {Component, ChangeDetectionStrategy, input} from '@angular/core';

/**
 * Zeigt ein Bild vollständig (object-contain) und füllt den übrigen Platz
 * mit einer abgedunkelten, geblurrten Kopie des Bildes. Die Komponente füllt
 * den Elternknoten; Größe, Rundung und Overlays bleiben beim Aufrufer.
 */
@Component({
    selector: 'kaz-blur-image',
    templateUrl: './kaz-blur-image.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {class: 'relative flex h-full w-full items-center justify-center overflow-hidden'}
})
export class KazBlurImageComponent {
  readonly src = input.required<string>();
  readonly alt = input<string>('Bild');
  readonly placeholder = input<boolean>(false);
}
